import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_9drv3ax8mr: FaireBrandEntity = {
  token: "b_9drv3ax8mr",
  type: "brand",
  name: "Plush Looks",
  avatarUrl:
    "https://cdn.faire.com/fastly/eb24ed2eae4db9e867dedaa488113333e450495fecf8f57454e1a9694b7c85cb.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/5f489074adf4a94e79a30f25d54c305b1d75d2005fce14941f06542efa0fbdf4.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/eb24ed2eae4db9e867dedaa488113333e450495fecf8f57454e1a9694b7c85cb.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/5f489074adf4a94e79a30f25d54c305b1d75d2005fce14941f06542efa0fbdf4.jpeg",
  location: "Los Angeles, CA, USA",
  minimumOrderDollars: 150,
  rating: 3.6,
  reviewCount: 77,
  isInsider: true,
  description:
    "Elevate Your Wholesale Apparel Experience with Plush Looks! Discover the Best Deals in Los Angeles\n\nWe haven't raised the prices, and the prices include tax. There will be no additional tax charges.\n\nWelcome to Plush Looks – your ultimate destination for exceptional women's wholesale apparel. Situated in the heart of Los Angeles, we are dedicated to curating a vast array of fashion-forward clothing choices that seamlessly blend the latest trends with unbeatable affordability. If you're in pursuit of chic and cost-effective women's fashion, your quest concludes at Plush Looks. Explore our collection now!",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:45:04.074Z",
    importedBy: "entity-db-cli",
  },
};
